import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, mergeMap, of } from 'rxjs'

import { show_error_action } from '../action/common/common.action'
import { EmployeeBankingInformationAPIModel } from 'src/models/api.model'
import { FETCH_EMPLOYEE_BANKING_INFO, FETCH_EMPLOYEE_BANKING_INFO_SUCCESS } from '../action/employee.action'
import { EmployeeService } from 'src/services/employee/employee.service'

@Injectable()
export class EmployeeEffects {
  constructor(private actions$: Actions, private employeeService: EmployeeService) {}

  fetch_employee_banking_info$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_EMPLOYEE_BANKING_INFO),
      mergeMap(action =>
        this.employeeService.callGetEmployeeBankingInfoApi(action.employeeId).pipe(
          mergeMap((response: EmployeeBankingInformationAPIModel[]) => [
            FETCH_EMPLOYEE_BANKING_INFO_SUCCESS({ bankingInfo: response })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
